import * as helper from './helper';

export default class VideoPlayer {
	constructor(elem) {
		this.video = elem;
		this.supportsPlayType = !!document.createElement('video').canPlayType;
	}

	/**
	 * Turn native controls of video On/Off
	 *
	 * @param {boolean} state
	 */
	showNativeControls(state = false) {
		this.video.controls = state;
	}

	/**
	 * Starts playback of video if it is not already playing
	 */
	play() {
		if (this.video.ended || this.video.paused) {
			this.video.play();
		}
	}

	/**
	 * Pauses video if it is not already stopped
	 */
	pause() {
		if (!this.video.ended && !this.video.paused && typeof this.video.pause === 'function') {
			this.video.pause();
		}
	}

	/**
	 * Simulates a stop (which native Video elements dont have) by pausing the video and
	 * setting its playhead back to 0;
	 */
	stop() {
		this.pause();
		this.video.currentTime = 0;
	}

	/**
	 * Toggles the mute on a video
	 */
	toggleMute() {
		this.video.muted = !this.video.muted;
	}

	/**
	 * Turn muted on or off dedicated
	 *
	 * @param {boolean} mute
	 */
	set muted(mute) {
		this.video.muted = mute;
	}

	/**
	 * Get the muted state of the video
	 */
	get muted() {
		return this.video.muted;
	}

	/**
	 * Set the new poster
	 *
	 * @param {string} newPoster
	 */
	set poster(newPoster) {
		this.video.setAttribute('poster', newPoster);
	}

	/**
	 * Sets a new source for the video
	 *
	 * Expects an array ob objects like:
	 *
	 * [
	 *  {type: 'video/mp4', src: 'https://.....'},
	 * 	{type: 'video/webm', src: 'https://.....'},
	 *  {type: 'video/ogg', src: 'https://.....')}
	 * ]
	 *
	 * @param newSources
	 */
	changeVideo(newSources) {
		this._removeExistingSources();

		if (this.supportsPlayType) {
			// If it supports .canPlayType() we just set the src of the first matching video element
			for (let n = 0; n < newSources.length; n++) {
				let mySource = newSources[n];
				if (this.video.canPlayType(mySource.type) !== '') {
					this.video.setAttribute('src', mySource.src);
					break;
				}
			}
		} else {
			// does not support canPlayType, so we create new sources
			this.pause();
			for (let n = 0; n < newSources.length; n++) {
				let mySource = newSources[n];
				let newElement = document.createElement('source');
				newElement.setAttribute('src', mySource.src);
				newElement.setAttribute('type', mySource.type);
				this.video.appendChild(newElement);
			}
			if (typeof this.video.load === 'function') {
				this.video.load();
			}
			this.play();
		}
	}

	/**
	 * Remove possible old <sources> elements
	 *
	 * @private
	 */
	_removeExistingSources() {
		let sources = this.video.childNodes;
		while(sources.length > 0) {
			helper.remove(sources[0]);
		}
	}

}
